// import _ from 'lodash';
import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const create = content =>
  request({
    baseURL: API.BASE_URL,
    url: API.INVOICE_ROW,
    method: 'POST',
    data: content,
  });

const update = content =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.INVOICE_ROW}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const remove = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.INVOICE_ROW}/${id}`,
    method: 'DELETE',
  });

const getByInvoice = (invoiceId, page) =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.INVOICE_ROW}`,
    method: 'GET',
    params: {
      page: page || 1,
      pageSize: 5,
      filter: [
        {
          type: 'eq',
          field: 'invoice',
          value: invoiceId,
        },
      ],
      'order-by': [
        {
          type: 'field',
          field: 'rowNumber',
          direction: 'asc',
        },
      ],
    },
    paramsSerializer: params => qs.stringify(params),
  });

const InvoiceRowService = {
  getByInvoice,
  create,
  update,
  remove,
};

export default InvoiceRowService;
